import { combineReducers } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import { CityQuery } from '@/Module/Auth/Store/Query/CityQuery';
import { ProvinceQuery } from '@/Module/Auth/Store/Query/ProvinceQuery';
import { ReferQuery } from '@/Module/Auth/Store/Query/ReferQuery';
import { AuthSlice } from '@/Module/Auth/Store/Slice';
import { CommentSlice } from '@/Module/Comment/Store/Slice';
import { ContactUsSlice } from '@/Module/Contact/Store/Slice';
import { CoreSlice } from '@/Module/Core/Store/Slice';
import { CampaignQuery, StatisticsQuery } from '@/Module/DefaultLayout/Store/Query';
import { LayoutSlice } from '@/Module/DefaultLayout/Store/Slice';
import { ExamSlice } from '@/Module/Exam/Store/Slice';
import { CategoryListQuery } from '@/Module/Grade/Store/Query/CategoryListQuery';
import { GradeSlice, LevelSlice } from '@/Module/Grade/Store/Slice';
import { CategoryLessonSectionListSlice } from '@/Module/HomePage/Store/Slice';
import { CourseSlice, LessonSectionSlice, LessonSlice } from '@/Module/Lesson/Store/Slice';
import { LiveSlice } from '@/Module/Live/Store/slice';
import { PostSlice } from '@/Module/Post/Store/Slice';
import { NotificationSlide } from '@/Module/Profile/Store/Slice';
import { QuestionTypeQuery } from '@/Module/Question/Store/Query/QuestionTypeQuery';
import { FAQSlice } from '@/Module/Question/Store/Slice';
import { SearchResultSlice } from '@/Module/Search/Store/Slice';
import { SubscriptionSlice } from '@/Module/Subscription/Store/Slice';
import { LessonTeacherSlice, TeacherCategorySlice, TeacherSlice } from '@/Module/Teacher/Store/Slice';
import { WorkspaceSlice } from '@/Module/Workspace/Store/Slice';

const appReducer = combineReducers({
  [CoreSlice.name]: CoreSlice.reducer,
  [AuthSlice.name]: AuthSlice.reducer,
  [LessonSlice.name]: LessonSlice.reducer,
  [LessonSectionSlice.name]: LessonSectionSlice.reducer,
  [GradeSlice.name]: GradeSlice.reducer,
  [LevelSlice.name]: LevelSlice.reducer,
  [LayoutSlice.name]: LayoutSlice.reducer,
  [CommentSlice.name]: CommentSlice.reducer,
  [TeacherSlice.name]: TeacherSlice.reducer,
  [LessonTeacherSlice.name]: LessonTeacherSlice.reducer,
  [TeacherCategorySlice.name]: TeacherCategorySlice.reducer,
  [ContactUsSlice.name]: ContactUsSlice.reducer,
  [FAQSlice.name]: FAQSlice.reducer,
  [SearchResultSlice.name]: SearchResultSlice.reducer,
  [CategoryLessonSectionListSlice.name]: CategoryLessonSectionListSlice.reducer,
  [CourseSlice.name]: CourseSlice.reducer,
  [LiveSlice.name]: LiveSlice.reducer,
  [PostSlice.name]: PostSlice.reducer,
  [SubscriptionSlice.name]: SubscriptionSlice.reducer,
  [ExamSlice.name]: ExamSlice.reducer,
  [ProvinceQuery.reducerPath]: ProvinceQuery.reducer,
  [CityQuery.reducerPath]: CityQuery.reducer,
  [ReferQuery.reducerPath]: ReferQuery.reducer,
  [QuestionTypeQuery.reducerPath]: QuestionTypeQuery.reducer,
  [CategoryListQuery.reducerPath]: CategoryListQuery.reducer,
  [CampaignQuery.reducerPath]: CampaignQuery.reducer,
  [StatisticsQuery.reducerPath]: StatisticsQuery.reducer,
  [WorkspaceSlice.name]: WorkspaceSlice.reducer,
  [NotificationSlide.name]: NotificationSlide.reducer,
});

type IAppReducerType = typeof appReducer;

const rootReducer: IAppReducerType = (state, action) => {
  if (action.type === HYDRATE) {
    return {
      ...state, // use previous state
      ...action.payload, // apply delta from hydration
      layout: {
        ...state?.layout,
        ...action.payload?.layout,
        menuIsInner: state?.layout.menuIsInner,
      },
      [ProvinceQuery.reducerPath]: {
        ...action.payload?.[ProvinceQuery.reducerPath],
        ...state?.[ProvinceQuery.reducerPath],
      },
      [CategoryListQuery.reducerPath]: {
        ...action.payload?.[CategoryListQuery.reducerPath],
        ...state?.[CategoryListQuery.reducerPath],
      },
      [QuestionTypeQuery.reducerPath]: {
        ...action.payload?.[QuestionTypeQuery.reducerPath],
        ...state?.[QuestionTypeQuery.reducerPath],
      },
      [ReferQuery.reducerPath]: {
        ...action.payload?.[ReferQuery.reducerPath],
        ...state?.[ReferQuery.reducerPath],
      },
      [StatisticsQuery.reducerPath]: {
        ...action.payload?.[StatisticsQuery.reducerPath],
        ...state?.[StatisticsQuery.reducerPath],
      },
      // TODO: Check Please
      // core: {
      //   ...state?.core,
      //   ...action.payload?.core,
      //   initialed: state?.core.initialed ?? action.payload?.core ?? false,
      // },
    };
  }

  return appReducer(state, action);
};

export default rootReducer;
